import type { ReactNode } from 'react';
import { Box } from '@mui/material';

import type { PassengerFieldLevel } from '../passengerFields';
import { PassengerFieldLevelBadge } from './PassengerFieldLevelBadge';

interface Props {
  /** El nivel del campo, o ninguno si no lo condiciona ninguna decisión. */
  level?: PassengerFieldLevel;
  children: ReactNode;
}

/**
 * Una celda del formulario de pasajeros: el control y, DEBAJO, el renglón del
 * badge.
 *
 * El renglón existe SIEMPRE, tenga badge o no. Es la regla que mantiene a
 * todos los inputs de una fila sobre el mismo eje: con el badge fuera del
 * flujo, una celda con nivel es más alta que una sin él, y la fila deja de
 * leerse como una fila (#2374). Por eso lo envuelve todo lo que se dibuja en
 * este formulario —también los horarios de transfers y las celdas
 * bloqueadas—, y no solo los campos que declara la oferta.
 */
export function PassengerFieldSlot({ level, children }: Props) {
  return (
    <Box>
      {children}
      <Box sx={{ minHeight: 22 }}>
        {level && <PassengerFieldLevelBadge level={level} />}
      </Box>
    </Box>
  );
}
